<template>
   <div class="nav">

      <div class="nav_item" v-for="(item,index) in state.navList" @click="clickHref(item.pathUrl)">
        <img :src="item.icon" />
        <span>{{item.name}}</span>
      </div>
   </div>
</template>
<script setup  >

import { ref, onMounted, reactive } from "vue";
import * as echarts from "echarts";
import { useRouter } from "vue-router";
// console.log(props)
const props =defineProps({

  pathUrl: {
    type: String,
    default: () => "",
  },
})
const url = ref("https://lcamapp.oss-accelerate.aliyuncs.com/uploads/img")
const state = reactive({
  navList:[
    {name:"项目总揽",icon:require('../assets/img/newxmzl/gg.png'),pathUrl:"/gbzntyj"},
    {name:"高标准农田",icon:require('../assets/img/newxmzl/wlw.png'),pathUrl:"/plant"},
    {name:"运营状态",icon:require('../assets/img/newxmzl/sy.png'),pathUrl:"/gbyunying"},
    {name:"种植模型",icon:require('../assets/img/newxmzl/zz.png'),pathUrl:"/plantmoxing"},
    {name:"气象预警",icon:require('../assets/img/newxmzl/qx.png'),pathUrl:"/qihouYj"},
    {name:"智能灌溉",icon:require('../assets/img/newxmzl/gg.png'),pathUrl:"/zhinengGG"},
    {name:"病虫害管理",icon:require('../assets/img/newxmzl/bch.png'),pathUrl:"/binghai"}
  ]
})
const router = useRouter();
function clickHref(path){
  router.push(path)
}
// 返回上一页

  onMounted(() => {


  });




</script>
<style lang="less" scoped>
.nav{
  display: flex;
  justify-content: space-between;
  .nav_item{
    display: flex;
    flex-direction: column;
    align-items: center;
    img{
      width: 154px;
      height: 154px;
    }
    span{
      font-size: 40px;
      color: #19E1CB;
    }
  }
}
</style>
